'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoClickOutsideCheckbox = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactClickOutside = require('react-click-outside');

var _reactClickOutside2 = _interopRequireDefault(_reactClickOutside);

var _keyCode = require('appkit-react-utils/keyCode');

var _keyCode2 = _interopRequireDefault(_keyCode);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _SwitchBase = require('../utils/SwitchBase');

var _SwitchBase2 = _interopRequireDefault(_SwitchBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var babelPluginFlowReactPropTypes_proptype_Node = require('react').babelPluginFlowReactPropTypes_proptype_Node || require('prop-types').any;

var babelPluginFlowReactPropTypes_proptype_Element = require('react').babelPluginFlowReactPropTypes_proptype_Element || require('prop-types').any;

var babelPluginFlowReactPropTypes_proptype_CommonType = require('appkit-react-utils/commonType').babelPluginFlowReactPropTypes_proptype_CommonType || require('prop-types').any;

var Checkbox = function (_PureComponent) {
  _inherits(Checkbox, _PureComponent);

  function Checkbox(props) {
    _classCallCheck(this, Checkbox);

    var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));

    _this.onMouseDown = function () {
      _this.setState({
        hasOutLine: false
      });
    };

    _this.handleClickOutside = function () {
      _this.setState({
        hasOutLine: true
      });
    };

    _this.onKeyDown = function (evt) {
      if (evt.keyCode === _keyCode2.default.TAB) {
        _this.setState({
          hasOutLine: true
        });
      }
    };

    _this.state = {
      hasOutLine: true
    };
    return _this;
  }

  _createClass(Checkbox, [{
    key: 'render',
    value: function render() {
      var _ClassNames,
          _this2 = this;

      var _props = this.props,
          style = _props.style,
          className = _props.className,
          children = _props.children,
          switchTabIndex = _props.switchTabIndex,
          otherProps = _objectWithoutProperties(_props, ['style', 'className', 'children', 'switchTabIndex']);

      var classes = (0, _classnames2.default)('a-checkbox-wrapper', className, (_ClassNames = {}, _defineProperty(_ClassNames, 'a-checkbox-icon-wrapper', this.props.uncheckedIcon), _defineProperty(_ClassNames, 'a-checkbox-wrapper-disabled', this.props.disabled), _defineProperty(_ClassNames, 'a-checkbox-wrapper-checked', this.props.checked), _defineProperty(_ClassNames, 'without-outline', !this.state.hasOutLine), _ClassNames));

      var opt = {};
      if (typeof switchTabIndex === "number") {
        opt["tabIndex"] = switchTabIndex;
      }

      return _react2.default.createElement(
        'label',
        {
          ref: function ref(node) {
            return _this2.node = node;
          },
          style: style,
          className: classes,
          onMouseDown: this.onMouseDown,
          onKeyDown: this.onKeyDown
        },
        _react2.default.createElement(_SwitchBase2.default, Object.assign({
          type: 'checkbox',
          defaultCheckedIcon: _react2.default.createElement('span', { className: 'appkiticon icon-check-mark-fill' })
        }, opt, otherProps)),
        children !== undefined && children !== '' && _react2.default.createElement(
          'span',
          { className: 'a-checkbox-text' },
          children
        )
      );
    }
  }]);

  return Checkbox;
}(_react.PureComponent);

Checkbox.propTypes = Object.assign({}, {
  /**
   * name of the input
   */
  name: require('prop-types').string,

  /**
   * If `true`, the component is checked.
   */
  checked: require('prop-types').oneOfType([require('prop-types').bool, require('prop-types').string]),

  /*
   * The default state of our checkbox component.
   */
  defaultChecked: require('prop-types').bool,

  /**
   * If `true`, the checkbox will be disabled.
   */
  disabled: require('prop-types').bool,

  /**
   * The icon to display when the component is unchecked.
   */
  uncheckedIcon: typeof babelPluginFlowReactPropTypes_proptype_Element === 'function' ? babelPluginFlowReactPropTypes_proptype_Element : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Element),

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: typeof babelPluginFlowReactPropTypes_proptype_Element === 'function' ? babelPluginFlowReactPropTypes_proptype_Element : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Element),


  /**
   * Callback fired when the state is changed.
   */
  onChange: require('prop-types').func,

  /**
   * The content of checkbox
   */
  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Node)
}, babelPluginFlowReactPropTypes_proptype_CommonType === require('prop-types').any ? {} : babelPluginFlowReactPropTypes_proptype_CommonType);
exports.default = (0, _reactClickOutside2.default)(Checkbox);
var NoClickOutsideCheckbox = exports.NoClickOutsideCheckbox = Checkbox;